import { MultilineTextBox, MultilineTextBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../state/standardLoanStore';
import { showsFdilaAgreement } from '../functions/showsFdilaAgreement';

/** Only shown while the loan is under a FDILA agreement. */
export const FdilaAgreementTermsField = () => {
    const inForbearance = useStandardLoanStore((state) => state.setup.inForbearance);
    const value = useStandardLoanStore((state) => state.setup.forbearanceAgreementTerms);
    const context = useStandardLoanStore((state) => state.setupLoanContext);
    const updateSetup = useStandardLoanStore((state) => state.updateSetup);

    if (!showsFdilaAgreement(context) || !inForbearance) {
        return null;
    }

    return (
        <MultilineTextBox
            id='setupForbearanceAgreementTerms'
            value={value}
            onChange={(forbearanceAgreementTerms) => updateSetup({ forbearanceAgreementTerms: forbearanceAgreementTerms ?? '' })}
            label='Terms of FDILA Agreement'
            width='100%'
            height='96px'
            layoutStyle={MultilineTextBoxLayoutStyle.Horizontal}
            labelWidth='100px'
        />
    );
};
